import React from 'react'
interface Props {
  className?: string
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const BetaTag: React.FC<Props> = ({ className }) => {
  return (
    <span className="inline-block mr-[10px] bg-[#EFA329] text-[#011D58] text-[12px] font-secondary font-bold h-5 w-[46px] text-center leading-5 tracking-[0.5px] rounded">
      Beta
    </span>
  )
}
